import ApiClient from './ApiClient'

const API_NAME = 'WeConnect'
const BASE_PATH = 'top'

const client = new ApiClient(API_NAME)

export default {
  getMenu(businessId) {
    return client.get(`/business/${businessId}/${BASE_PATH}/menu`)
  },

  getNotices(businessId) {
    return client.get(`/business/${businessId}/${BASE_PATH}/notice`)
  },

  getStepSchedules(businessId) {
    return client.get(`/business/${businessId}/${BASE_PATH}/step-schedule`)
  },
}
